module.exports = __webpack_public_path__ + "1793882494189/fonts/fa-brands-400.fdf44bc.ttf";